import type { MutableRefObject } from 'react';

import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Resets interactions overlay internal state
 */
export const reset = (
  lastMousePositionRef: MutableRefObject<RelativeAbsolutePosition | undefined>,
  panDeltaRef?: MutableRefObject<number | undefined>,
) => {
  if (panDeltaRef) {
    panDeltaRef.current = undefined;
  }

  lastMousePositionRef.current = undefined;
};
